var render = function render(){var _vm=this,_c=_vm._self._c;return (this.lang!='en-US')?_c('div',[_c('slider-r-u')],1):_c('div',[_c('slider-e-n')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }